// extracted by mini-css-extract-plugin
export default {"SettingsJourneySettings":"JourneySettings_SettingsJourneySettings__Ow+9+"};